import { render, staticRenderFns } from "./sysModuleList.vue?vue&type=template&id=258a894e&scoped=true&"
import script from "./sysModuleList.vue?vue&type=script&lang=js&"
export * from "./sysModuleList.vue?vue&type=script&lang=js&"
import style0 from "./sysModuleList.vue?vue&type=style&index=0&id=258a894e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258a894e",
  null
  
)

export default component.exports